module.exports = __webpack_public_path__ + "static/media/zirsakht.452784f4.gif";